import React from 'react';
import FileExplorer from '../../components/FileExplorer/FileExplorer';
import { FileItem } from '../../types/files';
import { Mode } from 'types/modes';

interface FileExplorerContainerProps {
  onFileClick: (file: FileItem, options?: { preview?: boolean }) => void;
  isSidebarVisible: boolean;
  onToggleSidebar: () => void;
  onFileDeleted: (file: FileItem) => void;
  onFileRenamed: (oldFile: FileItem, newFile: FileItem) => void;
  previewTab: FileItem | null;
}

const FileExplorerContainer: React.FC<FileExplorerContainerProps> = ({
  onFileClick,
  isSidebarVisible,
  onToggleSidebar,
  onFileDeleted,
  onFileRenamed,
  previewTab,
}) => {
  return (
    <div className="file-explorer-container">
      <FileExplorer
        onFileClick={onFileClick}
        isSidebarVisible={isSidebarVisible}
        onToggleSidebar={onToggleSidebar}
        onFileDeleted={onFileDeleted}
        onFileRenamed={onFileRenamed}
        previewTab={previewTab}
      />
    </div>
  );
};

export default FileExplorerContainer; 